import { useMemo } from 'react';

import { useGetUserMe } from '@/api/REST/userMe';

export const useUserHasPrivilege = (privilege: string) => {
  const { data: user, isLoading, ...restProps } = useGetUserMe();
  const userPrivileges = useMemo(
    () => user?.privileges.map((priv) => priv.privilegeType) || [],
    [user?.privileges],
  );

  return {
    hasPrivilege: userPrivileges.includes(privilege),
    isLoading,
    ...restProps,
  };
};
